import { useState } from 'react';
import { Link } from 'react-router-dom';

const FOOTER_SECTIONS = [
  { title: 'Services', links: [['Web Development','/services'],['Web Design','/services'],['App Development','/services'],['SEO','/services'],['Digital Marketing','/services']] },
  { title: 'Company',  links: [['About Us','/about'],['Blog','/blog'],['Contact','/contact'],['Careers','/contact']] },
  { title: 'Contact',  links: [['chaturbhujarani78@gmail.com','mailto:chaturbhujarani78@gmail.com'],['+91 8699393272','tel:+918699393272'],['India (Remote)','/contact']] },
];

export default function Footer() {
  const [openSection, setOpenSection] = useState(null);

  const toggle = (title) => {
    setOpenSection(prev => prev === title ? null : title);
  };

  return (
    <footer className="bg-pure-black border-t border-white/10">
      <div className="container-max py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">

          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-5" aria-label="CodeViora home">
              <img src={require('../images/Codeviora.webp')} alt="CodeViora Logo" className="h-8 w-auto object-contain" />
            </Link>
            <p className="text-white/40 text-sm leading-relaxed max-w-xs">
              End-to-end IT services — web development, design, apps, SEO, and digital marketing for businesses that want to grow.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="https://www.linkedin.com/company/codeviora/" target="_blank" rel="noopener noreferrer" aria-label="CodeViora on LinkedIn"
                className="w-9 h-9 rounded-lg bg-white/5 hover:bg-white hover:text-black flex items-center justify-center text-white/40 transition-all">
                <i className="fab fa-linkedin-in text-sm"></i>
              </a>
            </div>
          </div>

          {/* Desktop Links */}
          <div className="hidden md:contents">
            {FOOTER_SECTIONS.map(({ title, links }) => (
              <div key={title}>
                <h3 className="text-xs font-bold tracking-widest uppercase text-white/30 mb-5">{title}</h3>
                <ul className="flex flex-col gap-3">
                  {links.map(([label, to]) => (
                    <li key={label}>
                      {to.startsWith('mailto:') || to.startsWith('tel:') ? (
                        <a href={to} className="text-sm text-white/40 hover:text-white transition-colors break-all">{label}</a>
                      ) : (
                        <Link to={to} className="text-sm text-white/40 hover:text-white transition-colors">{label}</Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Mobile Accordion */}
          <div className="md:hidden lg:hidden col-span-1 flex flex-col gap-0 border border-white/10 rounded-2xl overflow-hidden">
            {FOOTER_SECTIONS.map(({ title, links }) => (
              <div key={title} className="border-b border-white/10 last:border-b-0">
                <button
                  onClick={() => toggle(title)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left"
                  aria-expanded={openSection === title}
                >
                  <span className="text-xs font-bold tracking-widest uppercase text-white/50">{title}</span>
                  <span className={`w-6 h-6 rounded-full border border-white/20 flex items-center justify-center text-white/50 transition-transform duration-300 flex-shrink-0 ${openSection === title ? 'rotate-45' : ''}`}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M6 2v8M2 6h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                  </span>
                </button>

                {/* Accordion Content */}
                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openSection === title ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'}`}>
                  <ul className="px-5 pb-4 flex flex-col gap-3">
                    {links.map(([label, to]) => (
                      <li key={label}>
                        {to.startsWith('mailto:') || to.startsWith('tel:') ? (
                          <a href={to} className="text-sm text-white/40 hover:text-white transition-colors break-all">{label}</a>
                        ) : (
                          <Link to={to} className="text-sm text-white/40 hover:text-white transition-colors">{label}</Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container-max py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/25 text-xs">© {new Date().getFullYear()} CodeViora. All rights reserved.</p>
          <p className="text-white/25 text-xs">Made in India 🇮🇳</p>
        </div>
      </div>
    </footer>
  );
}